import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dev-device-irrigation",
  "use": "icon-dev-device-irrigation-usage",
  "viewBox": "0 0 220 220",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 220 220\" id=\"icon-dev-device-irrigation\"><path d=\"M113,165.5a57.38,57.38,0,0,1-40.82-16.91h0a57.8,57.8,0,0,1,0-81.63L113,26.14,153.83,67A57.73,57.73,0,0,1,113,165.5Zm0-126.64L78.56,73.32a48.78,48.78,0,0,0,0,68.91h0a48.73,48.73,0,0,0,68.91-68.91Z\" /><polygon points=\"186.6 192 33.4 192 19.36 161.17 27.55 157.44 39.19 183 180.81 183 192.45 157.44 200.64 161.17 186.6 192\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol